import { Component, OnInit } from "@angular/core";
import { BigmlFieldDTO } from "@DTOS";

@Component({
    templateUrl: "./tipo-regression-configuracion-modal.component.html",
    styleUrls: ["./tipo-regression-configuracion-modal.component.scss"]
})
export class TipoRegressionConfiguracionModalComponent implements OnInit {
    public campo: BigmlFieldDTO = new BigmlFieldDTO();

    constructor() { }

    ngOnInit(): void {
    }

}
